import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';
import type { JPDExperience } from '../../utils/experience/types.tsx';

export const issueConnectionFieldValueUpdate: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.issue-update.connection-field', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const issueConnectionFieldsValuesUpdateBulk = createJpdExperience(
	new UFOExperience('jpd.issue-update-bulk.connection-field', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const connectionBetaConfigToggleChange = createJpdExperience(
	new UFOExperience('jpd.connection-beta-config.toggle-change', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const connectionBetaConfigLoad = createJpdExperience(
	new UFOExperience('jpd.connection-beta-config.load', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
